import { AudioMath } from "../../AudioMath";

export class Note
{
  midiKey:number;
  velocity:number;
  start:number;
  end:number;

  get duration()
  {
    return this.end - this.start;
  }

  set duration( value:number )
  {
    this.end = this.start + value;
  }

  get keyInfo()
  {
    return AudioMath.midiKeyToKeyInfo( this.midiKey );
  }

  set keyInfo( value:string )
  {
    this.midiKey = AudioMath.keyInfoToMidiKey( value );
  }


  static create( keyInfo:string, start:number, duration:number )
  {
    let note = new Note();
    note.keyInfo = keyInfo;
    note.start = start;
    note.duration = duration;
    note.velocity = 1;
    
    return note;
  }

}
